











































































import { Vue, Component } from 'vue-property-decorator'
import SearchBarMobile from '@/components/misc/SearchBar/SearchBarMobile.vue'
import NetworkMenu from './NetworkSettings/NetworkMenu.vue'
import {
    DEFAULT_NETWORK_ID,
    cChainExplorerURL,
    cChainExplorerURL_test,
    statusURL,
    statusURL_test,
} from '@/store/modules/network/network'

@Component({
    components: {
        SearchBarMobile,
        NetworkMenu,
    },
})
export default class NavbarMobile extends Vue {
    isDrawer = false
    isSearch = false

    onsearch(val: string) {
        this.$router.push({ path: '/search', query: { query: val } })
    }

    get showSearch() {
        return this.$router.currentRoute.name === 'Home' ? false : true
    }

    get logoColor() {
        return DEFAULT_NETWORK_ID === 1 ? 'black' : 'white'
    }

    get navColor() {
        return '#fff'
    }

    get cChainURL() {
        return DEFAULT_NETWORK_ID === 1
            ? cChainExplorerURL
            : cChainExplorerURL_test
    }

    get tokensURL() {
        return DEFAULT_NETWORK_ID === 1
            ? 'https://avascan.info/tokens'
            : 'https://testnet.avascan.info/tokens'
    }

    get statsURL() {
        return 'https://stats.avax.network/'
    }

    get isMainnet() {
        return DEFAULT_NETWORK_ID === 1 ? true : false
    }

    get statusPageURL() {
        return DEFAULT_NETWORK_ID === 1 ? statusURL : statusURL_test
    }

    closeSearch(val: boolean) {
        this.isSearch = val
    }
}
